import { api } from './api';

export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  lastUsedAt: string | null;
  createdAt: string;
}

export interface MintedKey {
  id: string;
  name: string;
  prefix: string;
  key: string; // full plaintext — shown once
}

/** MCP API-key management (mint / list / revoke). */
export const apiKeysApi = {
  list: async (workspaceId: string): Promise<ApiKey[]> => {
    const r = await api.get<ApiKey[]>(`/api/workspaces/${workspaceId}/api-keys`);
    return r.data;
  },
  mint: async (workspaceId: string, name: string): Promise<MintedKey> => {
    const r = await api.post<MintedKey>(`/api/workspaces/${workspaceId}/api-keys`, { name });
    return r.data;
  },
  revoke: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/api/workspaces/${workspaceId}/api-keys/${id}`);
  },
};

/** The public MCP endpoint an agent connects to. */
export function mcpEndpoint(): string {
  const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
  return `${base.replace(/\/$/, '')}/api/mcp`;
}
